module.exports = __webpack_public_path__ + "img/8.5.COD.06e3113e.png";